export default "__VITE_ASSET__FIYoUkue__"